import React from 'react'
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {injectIntl } from 'react-intl'

import Label from '../label';

class Captcha extends React.Component {
    static CALLBACK_METHODE_NAME = "reCaptchaCallbackMethodeName"
    static CALLBACK_EXPIRED_METHODE_NAME = "reCaptchaCallbackExpiredMethodeName"
    static contextTypes = {
        store: PropTypes.object.isRequired
    };

    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        onChange: PropTypes.func,
        size: PropTypes.oneOf(['compact', 'normal', 'invisible'])
    }

    state = { siteKey: false  }

    componentDidMount() {
        let {store} = this.context
        let {locale} = this.props.intl

        this.state.siteKey = store.app.config.captcha.publicKey
        !store.recaptchaScript && (store.recaptchaScript = [])
        store.recaptchaScript[locale] ? this.init() : this.setScript() && this.initCallbackMethodes()
        this.setState(this.state)
    }

    init() {
        let {locale} = this.props.intl
        this.context.store.recaptchaScript[locale] = true
        this.forceUpdate();
    }

    setScript() {
        let {locale} = this.props.intl
        this.context.store.recaptchaScript[locale] = true
        let script = React.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?hl=" + this.props.intl.locale;
        script.async = true;
        script.onload = this.init.bind(this)
        ReactDOM.findDOMNode('').appendChild(script)
        return true
    }

    initCallbackMethodes() {
        let This = this;
        window && (window[Captcha.CALLBACK_METHODE_NAME] = response => This.props.onChange(response))
        window && (window[Captcha.CALLBACK_EXPIRED_METHODE_NAME] = () => This.props.onChange())
        return true
    }
    
    render() {
        let { label=false, className=false, size } = this.props;
        let { siteKey=false } = this.state;

        return <div className={"form form-captcha" + (className ? ' ' + className : '')}>
            <Label>{label}</Label>
            <div className="form-data">
                {siteKey && <div className="g-recaptcha"
                    data-callback={Captcha.CALLBACK_METHODE_NAME}
                    data-expired-callback={Captcha.CALLBACK_EXPIRED_METHODE_NAME}
                    data-sitekey={siteKey}
                    data-size={size}></div>}
            </div>
        </div>
    }
}

Captcha.defaultProps = {
    size: "normal"
};

export default injectIntl(Captcha)

